import { LineItem, Order, RevenuePeriod } from '@vendasta/sales-orders';
import { TaxOptions } from '@vendasta/sales-orders/lib/_internal';

export function getTaxAmountForRevenuePeriod(salesOrder: Order, revenuePeriod: RevenuePeriod): number {
  return salesOrder.lineItems.reduce((totalTax, lineItem) => {
    const revenue = lineItem.currentRevenue.revenueComponents.find((component) => component.period === revenuePeriod);
    if (!revenue) {
      return totalTax;
    }
    const lineItemTax = getTaxAmountOfLineItemForRevenuePeriodPrice(
      revenue.value,
      lineItem.quantity,
      lineItem?.taxRateIds,
      salesOrder.taxOptions,
    );
    return totalTax + lineItemTax;
  }, 0);
}

export function getTaxAmountOfLineItemForRevenuePeriodPrice(
  price: number,
  quantity: number,
  taxRateIds: string[],
  taxOptions: TaxOptions[],
): number {
  if (!taxOptions?.length || !taxRateIds?.length) {
    return 0;
  }
  let lineItemTax =
    taxRateIds?.reduce((taxTotal, taxRateId) => {
      const taxRate = taxOptions.find((taxOption) => taxOption.taxRateId === taxRateId);
      if (taxRate) {
        return taxTotal + (price * taxRate.percentageMultiplier) / 100;
      }
      return taxTotal;
    }, 0) || 0;
  if (quantity > 0) {
    lineItemTax = lineItemTax * quantity;
  }

  // Round to 2 decimal places
  return Math.round(lineItemTax * 10000) / 100;
}

export function getRevenueTotalFromLineItems(lineItems: LineItem[], revenuePeriod?: RevenuePeriod): number {
  if (revenuePeriod) {
    return lineItems
      .map((lineItem) => {
        const total = lineItem.currentRevenue.revenueComponents
          .filter((component) => component.period === revenuePeriod)
          .reduce((total, rev) => total + (rev.value || 0), 0);
        return lineItem.quantity > 0 ? total * lineItem.quantity : total;
      })
      .reduce((total, rev) => total + (rev || 0), 0);
  }

  return lineItems
    .map((lineItem) => {
      const total = lineItem.currentRevenue.revenueComponents.reduce((total, rev) => total + (rev.value || 0), 0);
      return lineItem.quantity > 0 ? total * lineItem.quantity : total;
    })
    .reduce((total, rev) => total + (rev || 0), 0);
}
